export default "__VITE_ASSET__RrAr$ITj__"